import React from 'react';
import styled from 'styled-components';
import { FieldHeader } from 'components/Elements/FieldHeader';
import { Checkbox, FormControl, FormControlLabel } from '@mui/material';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem 0 2rem 0;
`;

const CheckboxWrapper = styled.div`
	margin-top: 3rem;
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
`;

const ErrorWrapper = styled.div`
	padding-top: 2rem;

	span {
		color: ${(props) => props.theme.error};
		font-size: 1.3rem;
	}
`;

export const CheckboxSet = ({
	error,
	source,
	name,
	disabled = false,
	value,
	onChange,
	label,
	required,
	translation,
}) => {
	const renderError = () => {
		if (!error) {
			return <></>;
		}

		return <ErrorWrapper>{error}</ErrorWrapper>;
	};

	const handleChange = (newValue) => {
		const fieldValues = value || [];

		if (fieldValues.indexOf(newValue) !== -1) {
			fieldValues.splice(fieldValues.indexOf(newValue), 1);
		} else {
			fieldValues.push(newValue);
		}

		onChange(fieldValues);
	};

	const renderCheckboxes = () => {
		return source.map((field, index) => {
			return (
				<FormControl fullWidth key={`option-${index}`} required={required}>
					<FormControlLabel
						control={
							<Checkbox
								value={value}
								name={`${name}[]`}
								checked={value.indexOf(field) !== -1}
								tabIndex={-1}
								disableRipple
								disabled={disabled}
								onChange={() => handleChange(field)}
							/>
						}
						label={field}
					/>
				</FormControl>
			);
		});
	};

	return (
		<Wrapper>
			<FieldHeader
				label={label}
				required={required}
				translation={translation}
			/>
			<CheckboxWrapper>{renderCheckboxes()}</CheckboxWrapper>
			{renderError()}
		</Wrapper>
	);
};
